import React from 'react';
import copy from 'fast-copy';
import { Draggable } from 'react-smooth-dnd';
import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { values } from '../../../../Shared/utils';
import { useEventContext } from '../../../../Context/Event/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useAppContext } from '../../../../Context/App/Provider';
import { roles } from '../../../../Shared/utils';

export default function ActiveColumn({ column, renaming, setRenaming, groupId, setEditingDiskHealthPercentageComputingRules, nextColumns, setNextColumns }) {
  const { t } = useTranslation();
  // const [{ reportingColumns }, dispatch] = useReportingContext();
  // const [{ reportingColumnsLoaded }, eventDispatch] = useEventContext();
  const [{ user }] = useAppContext();

  const handleChangeColumn = (column, type, value = null) => {
    const columns = copy(nextColumns);
    const colIndex = columns.findIndex(col => col.field === column.field);

    if (type === 'name') {

      // console.log("22 - columns[colIndex].headerName=", columns[colIndex].headerName);
      // console.log("23 - renaming.name=", renaming.name);

      if (columns[colIndex].headerName !== renaming.name) {
        columns[colIndex].customHeaderName = true;
        columns[colIndex].headerName = renaming.name;
        setRenaming({active: false, field: '', name: '', customHeaderName: true});
      }
      else {
        setRenaming({ active: false });
      }
    }

    if (type === 'print') {
      columns[colIndex].print = value;
    }

    // console.log("36 - reportingColumns=", columns);
    // eventDispatch({ reportingColumnsLoaded: true });

    setNextColumns(columns);
    // dispatch({ reportingColumns: columns });
    // console.log("38 - reportingColumns...");
  };

  const handleRemoveColumn = (column) => {
    const newColumns = copy(nextColumns);
    const colIndex = newColumns.findIndex(col => col.field === column.field);

    newColumns.splice(colIndex, 1);

    // console.log("46 - reportingColumns=", newColumns);
    // eventDispatch({ reportingColumnsLoaded: true });

    setNextColumns(newColumns);
    // dispatch({ reportingColumns: newColumns });
    // console.log("49 - reportingColumns...");
  };

  const maxPrintColumnsReached = () => {
    if (values.maxReportingPrint === 0) return false;
    return nextColumns.filter(col => col.print).length >= values.maxReportingPrint;
  };


  // console.log("53 - column=", column);
  // console.log("54 - renaming=", renaming);

  return (
    <Draggable key={column.field} className="category__column active__columns">
      <div className="column__name">
        {(renaming.active && renaming.field === column.field) ? (
          <>
            <TextField
              id='column-rename'
              variant='standard'
              value={renaming.name}
              onChange={e => {
                // console.log("56 - column=", column);
                setRenaming({ ...renaming, name: e.target.value })
              }
              }
            />

            <span
              title={t('global.validate')}
              className='material-icons check'
              onClick={() => handleChangeColumn(column, 'name')}
            >check</span>
          </>
        ) : (
          <p>{column.headerName}</p>
        )}

        {renaming.active ? null : (
          <span
            className='material-icons-outlined'
            title={`${t('global.edit')} ${t('global.name')}`}
            onClick={() => {              
              setRenaming({ active: true, field: column.field, name: column.headerName })
            }
            }
          >edit</span>
        )}
        
        {true || groupId === null || user.roleId === roles.user || (column.field !== 'disk_wipe_$$_disk_health_percentage' && column.field !== 'disks_wipe_$$_disk_health_percentage') || renaming.active ? null : (
          <span
            className='material-icons-outlined'
            title={`${t('reporting.columns.disk_health_percentage_rules.edit')}`}
            onClick={() => {
              setEditingDiskHealthPercentageComputingRules(true);
            }}
          >settings</span>
        )}
      </div>

      <div className="actions">
        {/* <div
          className="checkbox"
          title={maxPrintColumnsReached() ? t('reporting.columns.print_max', {x: values.maxReportingPrint}) : null}
        >
          <input
            type="checkbox"
            checked={column.print}
            id={'print-' + column.field}
            disabled={!column.print && maxPrintColumnsReached()}
            // Only allow up to the defined number of printable columns
            onChange={e => handleChangeColumn(column, 'print', e.target.checked)}
          />

          <label style={{fontSize: '14px'}} htmlFor={'print-' + column.field}>{t('global.actions.print')}</label>
        </div> */}

        <span className='material-icons remove' onClick={() => handleRemoveColumn(column)}>remove_circle_outline</span>
        <span className='material-icons drag-handle'>drag_handle</span>
      </div>
    </Draggable>
  );
}
